import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';
import { throwErrorWithId } from '@pypestream/utils';

import {
  checkForErrors,
  getPypeConnections,
  type PlatformConnection,
} from '../../utils';
import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';

/**
 * Deletes a Live Agent Platform connection. The backend clears the routing on
 * every pype that was bound to it (`deletePypeConnection` →
 * `applyAgentRoutingToPypes` with null values), so no pype is touched here.
 *
 * Note this deletes a `PypeConnection` row, not a pype — the previous
 * implementation deleted a real pype, which is why connector pypes used to
 * accumulate in the project.
 */
export const deleteLiveAgentPlatform = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{
  pypeConnections: PlatformConnection[];
  cb?: () => void;
} | void> => {
  if (event.type !== 'deleteLiveAgentPlatform') {
    return;
  }

  const projectId = ctx.project?.id;

  if (!projectId) {
    throwErrorWithId('Project ID is required');
    return;
  }

  const { id, cb } = event.payload;

  const response = await urqlGql.deletePypeConnection({ id });
  checkForErrors(response);

  const pypeConnections = await getPypeConnections({ projectId });

  return { pypeConnections, cb };
};
